import { map, find } from 'lodash';

class ActivityFormController {
  constructor(currentPropertyService, $scope, $state, activitiesService, integrationApiService, messageService, markdownService, access) {
    this.currentProperty = currentPropertyService;
    this.$scope = $scope;
    this.$state = $state;
    this.activitiesService = activitiesService;
    this.integrationApiService = integrationApiService;
    this.messageService = messageService;
    this.marked = markdownService;
    this.access = access;
  }

  $onInit () {
    this.property = this.currentProperty.get();
    this.isAdmin = this.access.check('admin');

    this.activity = this.activity || {
      description: ''
    };

    this.activity.selectedcategories = this.activity.categories || [];
    this.activity.property_id = this.activity.property_id || this.property.id;
    this.currencySymbol = this.property.currency_symbol;
    this.activity.event_status_id = (this.activity.event_status_id) ? this.activity.event_status_id.toString() : '0';
    this.hasIntegration = !!this.property.integration;

    if (this.hasIntegration) {
        return this.integrationApiService.integrationActivityCollect(this.property.id).then(response => {
            this.importedActivities = response.map(activity => {
                if (activity.integration_location){
                    activity.name = activity.name + ' @ ' + activity.integration_location_name;
                }
                return activity;
            });
        });
    }
  }

  onSave () {
    if (!find(this.activity.selectedcategories, { id: this.activity.primary_category })) {
      this.messageService.failure(`You must select at least 1 category and set a primary category to continue`);
      this.messageService.push();
      this.saving = undefined;
      return Promise.reject({});
    }

    this.messageService.reset();

    this.activity.categories = map(this.activity.selectedcategories, 'id');

    let tempCats = this.activity.selectedcategories;
    let tempPrimaryCat = this.activity.primary_category;
    delete this.activity.selectedcategories;

    delete this.activity.upgrades;
    delete this.activity.days;

    return this.activitiesService.save(this.activity)
      .then(response => {
        if (this.activity.id) {
          this.messageService.success(`The class <strong>${this.activity.name}</strong> was successfully updated!`, [ `app.admin.class-edit({ 'activity' : ${this.activity.id}})` ]);
          this.$state.go('app.admin.classes');
          return;
        }

        this.activity.selectedcategories = tempCats;
        this.activity.primary_category = tempPrimaryCat;
        this.messageService.success(`The class <strong>${this.activity.name}</strong> was successfully created.`);
        this.$state.go('app.admin.class-edit', { activity: response.id });
        return;
      })
      .catch(error => {
        error.data = (error.data && error.data.original) || error.data;
        this.form.$api.setErrors(error.data);

        this.activity.selectedcategories = tempCats;
        this.activity.primary_category = tempPrimaryCat;

        let sourceElement = Object.keys(error.data);
        let verb = 'created';
        if (this.activity.id) {
          verb = 'updated';
        }

        if (sourceElement.length > 0) {
          let errors = '';
          for (let element of sourceElement) {
            errors += `<li>${this.messageService.formatError(element, error.data[element])}</li>`;
          }
          this.messageService.failure(`The class <strong>${this.activity.name}</strong> could not be successfully ${verb}: <ul>${errors}</ul>`);
        } else {
          this.messageService.failure(`The class <strong>${this.activity.name}</strong> could not be successfully ${verb}: ${error.statusText}`);
        }
        this.messageService.push();
      });
  }

  initialSlug () {
    if (!this.activity.id && this.$scope.$ctrl.form.slug.$untouched) {
      this.activity.slug = (this.activity.name ? this.activity.name.replace(/[^a-zA-Z\d\s]+/g, '')
        .replace(/[ ]+/g, '-')
        .replace(/--+/g, '-')
        .toLowerCase() : '');
    }
  }
}

ActivityFormController.$inject = [ 'currentPropertyService', '$scope', '$state', 'activitiesService', 'integrationApiService', 'messageService', 'markdownService', 'access' ];

export default ActivityFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/controllers/activity.form.controller.js